// extracted by mini-css-extract-plugin
module.exports = {"appMainColBox":"_1J6Qveg9WWr6hxRUbpBQXy","appMainColBoxNested":"_2dCdd929iPBWcv1OMk_4Rx"};